var styles = ({
    root: {
        color: 'red',
        whiteSpace: 'pre'
    },
});
export default styles;



//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles.ts
// module id = 838
// module chunks = 0